import { ca } from '@cian/analytics';

interface ITrackAnswerButtonClickArgs {
  objectId: number;
  rating: number;
  reviewsCount: number;
  reviewId: string;
}

export const trackNewAnswerSuccessfulCreation = ({
  objectId,
  reviewId,
  rating,
  reviewsCount,
}: ITrackAnswerButtonClickArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'Success',
    label: 'Reply',
    page: { extra: { reviewId, rating, reviewsCount } },
    products: [{ id: objectId, offerType: 'offer' }],
  });
};
